export enum ButtonState {
    BASE = "base",
    ON_HOVER = "onPointerDown",
    ON_CLICK = "onClick",
    INACTIVE = "inactive",
}



// WEBPACK FOOTER //
// ./src/app/controlElements/ButtonState.ts